import { AgentOSType } from "@inferno/renderer-shared-core";
import { DownloadIcon } from "../../../../../core/components/icons/DownloadIcon.component";
import { Remote } from "../../../../../core/components/remote/Remote.component";
import type { PwsPremiereMediaResponseData } from "@inferno/renderer-shared-core";
import { ButtonKind, FauxButton } from "../../../../../core/ui";
import Heading from "../../../../../core/ui/Heading.component";
import { CoastShowAudioBoxMP3DownloadNotice } from "./CoastShowAudioBoxMP3DownloadNotice.component";
import { coastMediaService } from "../../../../../core/services/Pws";

interface CoastShowAudioboxHighlightsProps {
  downloadLinks: PwsPremiereMediaResponseData[];
  osType: AgentOSType | null;
}

interface CoastShowAudioboxHighlightsLoaderProps {
  osType: AgentOSType | null;
  highlightsIds: string[];
}

export const CoastShowAudioboxHighlights = ({ downloadLinks, osType }: CoastShowAudioboxHighlightsProps) => {
  return (
    <>
      <section className="audiobox-section coast-highlights">
        <Heading level={4} className="audiobox-section-title">
          Highlights
        </Heading>

        <div className="audiobox-section-value">
          {downloadLinks.map(highlight =>
            highlight.metadata ? (
              <div key={highlight.identifier} className="highlight-episode">
                <li className="highlight-episode-title">{highlight.metadata.title}</li>
                <FauxButton kind={ButtonKind.CUSTOMIZED} className="media-link" download="download" to={highlight.url}>
                  <DownloadIcon />
                </FauxButton>
              </div>
            ) : null,
          )}
        </div>
      </section>
      <CoastShowAudioBoxMP3DownloadNotice osType={osType} />
    </>
  );
};

export const CoastShowAudioboxHighlightsLoader = ({
  highlightsIds,
  ...rest
}: CoastShowAudioboxHighlightsLoaderProps) => {
  if (!highlightsIds.length) {
    return null;
  }

  return (
    <Remote
      loader={() => coastMediaService.listHighlightsLinks(highlightsIds)}
      cacheKey={`coast-show-audiobox-highlights-${highlightsIds.join(",")}`}
      showLoading={true}
    >
      {({ data }) => (data?.length ? <CoastShowAudioboxHighlights downloadLinks={data} {...rest} /> : null)}
    </Remote>
  );
};
